import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';

const BG = 'https://images.unsplash.com/photo-1617938568125-b55e59775632?crop=entropy&cs=srgb&fm=jpg&q=85';

export default function PageHeader({ title, crumbs = [], image = BG }) {
  return (
    <section className="crumb-banner relative overflow-hidden">
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 crumb-overlay" />
      <div className="relative fx-container py-20 md:py-28">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: 'easeOut' }}>
          <div className="flex items-center text-sm text-emerald-200/90 gap-2 flex-wrap">
            <Link to="/" className="hover:text-white">Home</Link>
            {crumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-2">
                <ChevronRight size={14} />
                {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-white/90">{c.label}</span>}
              </span>
            ))}
          </div>
          <h1 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-white">{title}</h1>
          <div className="mt-5 w-20 h-1 rounded-full bg-gradient-to-r from-emerald-400 to-sky-400" />
        </motion.div>
      </div>
    </section>
  );
}
